import api from '../api/fileupload-api';
export default {
    uploadFileByBase64 (fileStr) {
        return new Promise((resolve, reject) => {
            api.uploadFileByBase64(fileStr).then(({ data }) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    uploadFile (formData, progressCallback) {
        return new Promise((resolve, reject) => {
            api.uploadFile(formData, progressCallback).then(({ data }) => {
                if (data.code === 200) {
                    resolve(data.result || {});
                } else {
                    reject(data);
                }
            });
        });
    },
    downloadImg(url){
        return new Promise((resolve, reject) => {
            api.downloadImg(url).then((response) => {
                if (response.data && response.data.type === 'blob') {
                    resolve(response);
                } else {
                    reject(response);
                }
            });
        });
    }
}